import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../../../../components/ui/card";
import { EntregoOpsItem } from "../../fund-baixa-resolution/types";

interface ImileOpsTableProps {
  opsList: EntregoOpsItem[];
  selectedOps: string[];
  onSelectionChange: (selectedOps: string[]) => void;
}

export function ImileOpsTable({
  opsList,
  selectedOps,
  onSelectionChange,
}: ImileOpsTableProps) {
  const handleToggleOp = (ops: string) => {
    if (selectedOps.includes(ops)) {
      onSelectionChange(selectedOps.filter((o) => o !== ops));
    } else {
      onSelectionChange([...selectedOps, ops]);
    }
  };

  const handleToggleAll = () => {
    if (selectedOps.length === opsList.length) {
      onSelectionChange([]);
    } else {
      onSelectionChange(opsList.map((op) => op.ops));
    }
  };

  if (!Array.isArray(opsList) || opsList.length === 0) {
    return null;
  }

  const allSelected = selectedOps.length === opsList.length;

  return (
    <Card>
      <CardHeader>
        <CardTitle>Selecione as bases</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          <div className="flex items-center space-x-3 p-3 rounded-lg border bg-muted/50">
            <input
              type="checkbox"
              id="imile-select-all"
              checked={allSelected}
              onChange={handleToggleAll}
              className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary cursor-pointer"
            />
            <label
              htmlFor="imile-select-all"
              className="text-sm font-medium cursor-pointer flex-1"
            >
              Selecionar Todas ({opsList.length})
            </label>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
            {opsList.map((op) => (
              // id prefixado: o htmlFor do entrego usa o id cru vindo do backend
              // (row_number), que colidiria se as duas tabelas coexistissem numa
              // tela. Aqui o prefixo torna o par label/input único.
              <div
                key={`imile-${op.id}`}
                className="flex items-center space-x-3 p-3 rounded-lg border hover:bg-accent/50 transition-colors"
              >
                <input
                  type="checkbox"
                  id={`imile-${op.id}`}
                  checked={selectedOps.includes(op.ops)}
                  onChange={() => handleToggleOp(op.ops)}
                  className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary cursor-pointer"
                />
                <label
                  htmlFor={`imile-${op.id}`}
                  className="text-sm font-medium cursor-pointer flex-1 font-mono"
                >
                  {op.ops}
                </label>
              </div>
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
